import React from 'react';
import {MainTop} from "../../../../group-container/main-top/Main-top";
import {ReactComponent as ArrayLeftIcon} from '../../../../../../../assets/main/groups/main-table/array-left.svg';
import {ResponseTable} from "./response-table/ResponseTable";
import AuthWrapper from "../../../../../../auth-wrapper/AuthWrapper";
import {useParams} from "react-router-dom";

export const StudentResponse = () => {
    const {groupId,lessonsId} = useParams();
    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Ответ студента'} tabs={false} setting={false} link={`/groups/${groupId}/lessons/${lessonsId}`} icons={<ArrayLeftIcon/>}/>
                <ResponseTable/>
            </div>
        </AuthWrapper>
    );
};

